import { useSelector } from 'core/use-cases/utilities/';

import type { Order } from 'core/domains';
import type { SelectorReturnFn } from 'core/use-cases/utilities';

export function useOrderSelector(): SelectorReturnFn<Order['data']> {
  const { data, status, updatedAt = 0 } = useSelector((state) => state.order);

  return {
    data,
    status,
    updatedAt,
  };
}

export function useOrderViewSelector() {
  const { view } = useSelector((state) => state.order);

  return view;
}
